"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.whatsapp.group': 'Gruppo WhatsApp',
    'route.whatsapp.group.create': 'Aggiungi gruppo WhatsApp',
    'route.whatsapp.dm': 'Contatto DM WhatsApp',
};
